import { withScope } from "@sentry/react";
import { int } from "aws-sdk/clients/datapipeline";
import React, { useState, useEffect, useContext } from "react";
import { Link } from 'react-router-dom';
import EventContext from "../../contexts/event";
import SocketClient from '../../helpers/connection';
import axios from "axios";
import {gql, useMutation} from "@apollo/client";
import {useIntl} from "react-intl";

// quiz footer components
const QuizFooter: React.FC<{ presentationId: string; screenMode?: boolean; }> = ({ presentationId, screenMode = false }) => {
  const eventContext = useContext(EventContext);
  const slug = document.location.pathname.split("/")[1] || "invalid";
  let token: any = localStorage.getItem(`token-${slug}`);
    const intl = useIntl();

  // update presentation quiz status
  const updateQuizStatus = async () => {
    await axios
        .post(
            `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/update-quiz-status`,
            {
              _id:presentationId,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
        ).then((res) => {
           console.log(res);
        });

  }
   // update user action and emit socket message using API
    function updateAction(jsonData:any) {
        console.log("updateAction >>> ",jsonData)
        console.log("updateAction >>> ",`${process.env.REACT_APP_SOCKET_URL}/quiz-moderator-action-change`)

        const headers = {
            'Content-Type': 'application/json',
        }

        axios.post(`${process.env.REACT_APP_SOCKET_URL}/quiz-moderator-action-change`, jsonData, {
            headers: headers
        })
            .then((response) => {

                console.log("response", response)
            })
            .catch((error) => {
                console.log("error", error)
            })
    }


  return (
    <footer className="quiz-footer ">
      <div className="container p-2 pb-0" >
        <div className="">
          <p className="d-flex  align-items-center" style={{ justifyContent: 'space-between' }}>
            <div className="p-2" >
            </div>

            <div> <span>Powered by</span>
              <img src="/images/e-slides-logo.png" alt="e-slides-logo" /> </div>
          </p>
        </div>

      </div>
    </footer>
  )
}

export default QuizFooter;
